var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 7.5H31.25C32.2446 7.5 33.1984 7.85119 33.9016 8.47631C34.6049 9.10143 35 9.94928 35 10.8333V34.1667C35 35.0507 34.6049 35.8986 33.9016 36.5237C33.1984 37.1488 32.2446 37.5 31.25 37.5H8.75C7.75544 37.5 6.80161 37.1488 6.09835 36.5237C5.39509 35.8986 5 35.0507 5 34.1667V10.8333C5 9.94928 5.39509 9.10143 6.09835 8.47631C6.80161 7.85119 7.75544 7.5 8.75 7.5H12.5",
    stroke: "#4361EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 2.5H14.375C13.3395 2.5 12.5 3.33947 12.5 4.375V8.125C12.5 9.16053 13.3395 10 14.375 10H25.625C26.6605 10 27.5 9.16053 27.5 8.125V4.375C27.5 3.33947 26.6605 2.5 25.625 2.5Z",
    stroke: "#4361EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubClipboard);
export default __webpack_public_path__ + "static/media/hub-clipboard.22f3fd8a.svg";
export { ForwardRef as ReactComponent };